import client from "lib/apolloClient/client";
import { getOrganizationSubjectsQuery, getStaffListQuery } from "./Queries";
import ACLStore from "lib/aclStore";
import _ from "lodash";

export const getStaffListFromCache = ({
  organizationId,
  searchText,
  grades,
  archivalState,
  courses,
  curriculumProgramIds,
  userArchivedFilters,
  academicYearIds,
}) => {
  let queryData = {};
  const skipTitle = ACLStore.can(
    "FeatureFlag:RemoveCourseDetailsFromStaffList"
  );
  try {
    queryData = client.readQuery({
      query: getStaffListQuery,
      variables: {
        organizationId,
        searchText,
        grades,
        archivalState,
        courses,
        curriculumProgramIds,
        userArchivedFilters,
        academicYearIds,
        skipTitle,
      },
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return queryData;
  else return {};
};

export const getOrganizationSubjectsFromCache = ({ id, filters }) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getOrganizationSubjectsQuery,
      variables: {
        id,
        filters,
      },
    });
  } catch (e) {
    console.warn(e);
    return {};
  }
  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};
